export default host => () =>
  `${host}/speakers/export`

